import { usePaging } from 'hooks/usePaging';
import { useCallback } from 'react';
import { useGetOrganizationUnitServiceTypeOptionsQuery } from 'services';
import { FindAllOrganizationUnitServiceTypeOptionsDto, UseQueryOptionsType } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useOrganizationUnitServiceTypeOptions(
  params: Omit<FindAllOrganizationUnitServiceTypeOptionsDto, 'pageIndex' | 'pageSize'>,
  options?: UseQueryOptionsType
) {
  const { ...restParams } = params;
  const { pageIndex, resetPage, nextPage } = usePaging(params);
  const {
    data: dataResponse,
    isLoading,
    isFetching
  } = useGetOrganizationUnitServiceTypeOptionsQuery(
    {
      pageIndex: pageIndex,
      pageSize,
      ...restParams
    },
    {
      ...options
    }
  );
  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);
  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      nextPage();
    }
  }, [hasMore, pageIndex]);

  return {
    serviceTypesOptions: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage
  };
}
